<template>
  <b-modal id="modal-error" centered :hide-header="true" :hide-footer="true" class="modal-content">
    <div class="modal-inner">
        <p class="modal-ttl-error">{{ title ? title : $t('order_cancellation_confirmation')}}</p>
        <p class="modal-txt-error mb50" v-html="content"></p>
        <div class="btn-base pos-center"><a href="javascript:;" class="modal-close" @click="$bvModal.hide('modal-error')"><p>{{ $t('ok') }}</p></a></div>
    </div>
  </b-modal>
</template>

<script>
  import { BModal, VBModal, BButton } from 'bootstrap-vue'

  export default {
    props: ['title', 'content', 'visible'],
    components: { BModal, BButton },
    directives: { BModal, VBModal, BButton }
  }
</script>

<style lang="css">
  .modal-txt-error {
    text-align: center;
  }
  .modal-ttl-error {
    color: #ff0000
  }
</style>